export enum Templates {
    TEMPLATE_1 = 'template1',
    TEMPLATE_2 = 'template2',
    TEMPLATE_3 = 'template3',
    DEFAULT = 'templateDefault',
}
